import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Base_URL2 } from '../../url';
import '../../Styling/PersonalDashboard.css';
import { useAuth } from '../../Context/AuthContext'; 

const PersonalDashboard = () => {
  const [tileData, setTileData] = useState([]);

  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState('monthly');
  const [lastRefreshed, setLastRefreshed] = useState('');
  const [expenseDetails, setExpenseDetails] = useState([]);
  const [showExpenseDetails, setShowExpenseDetails] = useState(false);
  const [amountView, setAmountView] = useState('none');
  
  const { user } = useAuth();

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  const [rawData, setRawData] = useState([]);

const [selectedFiscalYear, setSelectedFiscalYear] = useState(null); // ALL
const [selectedFiscalMonth, setSelectedFiscalMonth] = useState(null); // ALL


  const fiscalYears = Array.from({ length: 6 }, (_, i) => currentYear - i);

  const months = [
    { label: "Jan", value: 1 },
    { label: "Feb", value: 2 },
    { label: "Mar", value: 3 },
    { label: "Apr", value: 4 },
    { label: "May", value: 5 },
    { label: "Jun", value: 6 },
    { label: "Jul", value: 7 },
    { label: "Aug", value: 8 },
    { label: "Sep", value: 9 },
    { label: "Oct", value: 10 },
    { label: "Nov", value: 11 },
    { label: "Dec", value: 12 }
  ];

const fetchDashboardData = async () => {
  try {
    setLoading(true);
    setError(null);

    const params = {
      orgId: user?.organisationId,
    };

    if (selectedFiscalYear !== null)
      params.year = selectedFiscalYear;

    if (selectedFiscalMonth !== null)
      params.month = selectedFiscalMonth;

    const response = await axios.get(
      `${Base_URL2}/personalDashboard/GetTileGroupSummary`,
      { params }
    );

    if (Array.isArray(response.data)) {
      setRawData(response.data);

      const groupedData = response.data.reduce((acc, item) => {
        if (!acc[item.tileGroup]) {
          acc[item.tileGroup] = {
            tileGroup: item.tileGroup,
            totalAmount: 0
          };
        }

        acc[item.tileGroup].totalAmount += item.totalAmount;

        return acc;
      }, {});

      setTileData(Object.values(groupedData));
    } else {
      throw new Error("Invalid API response format");
    }

    setLastRefreshed(new Date().toLocaleTimeString());
  } catch (err) {
    setError(err.message || "Unable to fetch dashboard data");
    setTileData([]);
    setExpenseDetails([]);
  } finally {
    setLoading(false);
  }
};


useEffect(() => {
  if (user?.organisationId) {
    fetchDashboardData();
  }
}, [user?.organisationId]);

  console.log("===== RENDER DEBUG =====");
  console.log("Tile Data:", tileData);
  console.log("Expense Details State:", expenseDetails);
  console.log("Expense Details Length:", expenseDetails.length);

  const formatInLacs = (amount) => {
    const inLacs = (amount / 100000).toFixed(2);
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(inLacs);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  const getCategoryColor = (category) => {
    const colors = {
      'MISC': '#FF6B6B',
      'PARTY': '#4ECDC4',
      'TRAVEL': '#FFD166',
      'FOOD': '#06D6A0',
      'SHOPPING': '#118AB2',
      'BILLS': '#EF476F',
      'HEALTH': '#7209B7',
      'EDUCATION': '#F3722C'
    };
    return colors[category] || '#6C757D';
  };

const convertAmount = (amount) => {
  if (amount == null) return 0;

  switch (amountView) {
    case 'thousand':
      return (amount / 1000).toFixed(2) + " K";
    case 'lakh':
      return (amount / 100000).toFixed(2) + " L";
    case 'crore':
      return (amount / 10000000).toFixed(2) + " Cr";
    default:
      return formatCurrency(amount);
  }
};


  if (loading) {
    return (
      <div className="personal-dashboard-loading">
        <div className="personal-dashboard-spinner"></div>
        <p>Loading your dashboard...</p>
        <p className="personal-dashboard-loading-sub">Fetching data from server</p>
      </div>
    );
  }

const handleFilterSubmit = () => {
  fetchDashboardData();
};

  
  // const totalExpenseFromTiles = Array.isArray(tileData)
  // ? tileData.find(t => t.tileGroup === "Expenses")?.totalAmount || 0
  // : 0;




  return (
    <div className="personal-dashboard-container">
      {/* Header with Refresh Button */}
      <div className="personal-dashboard-header">
        <div className="personal-dashboard-header-left">
          <h1>Personal Dashboard</h1>
          {lastRefreshed && (
            <p className="last-refreshed">Last updated: {lastRefreshed}</p>
          )}
        </div>
      
      </div>

      {/* ===== Filter Section ===== */}
<div className="personal-dashboard-filter-section">
  <div className="personal-dashboard-filter-item">
    <label>Org ID</label>
    <input
  type="text"
  value={user?.organisationId || ''}
  className="personal-dashboard-filter-input"
  disabled
/>

  </div>


  <div className="personal-dashboard-filter-item">
    <label>Fiscal Year</label>
    <select
  value={selectedFiscalYear ?? ""}
  onChange={(e) =>
    setSelectedFiscalYear(e.target.value === "" ? null : Number(e.target.value))
  }
  className="personal-dashboard-filter-select"
>
  {/* Placeholder */}
  <option value="" >
    All
  </option>

  {fiscalYears.map(year => (
    <option key={year} value={year}>
      {year}
    </option>
  ))}
</select>


  </div>

  <div className="personal-dashboard-filter-item">
    <label>Fiscal Month</label>
   <select
  value={selectedFiscalMonth ?? ""}
  onChange={(e) =>
    setSelectedFiscalMonth(e.target.value === "" ? null : Number(e.target.value))
  }
  className="personal-dashboard-filter-select"
>
  {/* Placeholder */}
  <option value="" >
    All
  </option>

  {months.map(month => (
    <option key={month.value} value={month.value}>
      {month.label}
    </option>
  ))}
</select>


  </div>

  <div className="personal-dashboard-filter-item">
    <label>Amount View</label>
    <select
      value={amountView}
      onChange={(e) => setAmountView(e.target.value)}
      className="personal-dashboard-filter-select"
    >
      <option value="none">No Conversion</option>
      <option value="thousand">Thousands</option>
      <option value="lakh">Lakhs</option>
      <option value="crore">Crores</option>
    </select>
  </div>

  <div className="personal-dashboard-filter-item personal-dashboard-filter-submit">
  <label>&nbsp;</label>
  <button
    className="personal-dashboard-filter-submit-btn"
    onClick={handleFilterSubmit}
  >
    Submit
  </button>
</div>

</div>


<div className="personal-dashboard-grid">
  {tileData.length > 0 ? (
    tileData.map((item, index) => (
      <div key={index} className={`personal-dashboard-card ${
        item.totalAmount < 0 ? "negative-card" : "positive-card"
      }`}>
        <div className="personal-dashboard-card-header">
          <h3>{item.tileGroup}</h3>
        </div>

        <div className="personal-dashboard-card-body">
          <div className="personal-dashboard-card-amount">
            {convertAmount(item.totalAmount)}
          </div>
        </div>
      </div>
    ))
  ) : (
    <p>No dashboard data available</p>
  )}
</div>

   

      {/* ===== Expense Breakdown Section - BELOW THE GRID ===== */}
      <div className="expense-breakdown-section">
        <div className="expense-breakdown-card">
          <div 
            className="expense-breakdown-header"
            onClick={() => setShowExpenseDetails(!showExpenseDetails)}
          >
            <div className="header-left">
              <div className="header-icon">📊</div>
              <div>
                <h3>Expense Breakdown</h3>
                <p className="breakdown-subtitle">Detailed view of expense categories</p>
              </div>
            </div>
            <div className="header-right">
              <div className="total-amount-display">
                {/* <span className="total-label">Total:</span>
                <span className="total-amount">
                {convertAmount(
                  tileData.reduce((sum, item) => sum + item.totalAmount, 0)
                )}

                </span> */}
            </div>
              <div className={`expand-icon ${showExpenseDetails ? 'expanded' : ''}`}>
                ▼
              </div>
            </div>
          </div>
          
          {showExpenseDetails && (
            <div className="expense-breakdown-content">
              {/* Summary Stats */}
              {/* <div className="expense-summary-stats">
                <div className="stat-item">
                  <div className="stat-label">Categories</div>
                  <div className="stat-value">{expenseDetails.length}</div>
                </div>
                <div className="stat-item">
                  <div className="stat-label">Total Documents</div>
                  <div className="stat-value">
                  {expenseDetails.reduce((total, item) => total + (item.documentCount || 0), 0)}
                  </div>
              </div>
                <div className="stat-item">
                  <div className="stat-label">Period</div>
                  <div className="stat-value">
                    {selectedPeriod.charAt(0).toUpperCase() + selectedPeriod.slice(1)}
                  </div>
                </div>
              </div> */}

              {/* Expense Categories List */}
              <div className="expense-categories-list">

  {tileData.map((group, groupIndex) => {

    const groupItems = rawData.filter(
      item => item.tileGroup === group.tileGroup
    );

    const groupTotal = group.totalAmount;

    return (
      <div key={groupIndex} className="tilegroup-breakdown-block">

        {/* TileGroup Title */}
        <h4 className="tilegroup-title">{group.tileGroup}</h4>

        {groupItems.map((item, index) => {

          const percentage = groupTotal !== 0
            ? ((item.totalAmount / groupTotal) * 100).toFixed(1)
            : 0;

          return (
            <div key={index} className="expense-category-item">

              <div className="category-info">
                <div 
                  className="category-color-indicator"
                  style={{ backgroundColor: getCategoryColor(item.head3) }}
                />
                <div className="category-details">
                  <div className="category-name">{item.head3}</div>
                </div>
              </div>

              <div className="category-amounts">
                <div className="amount-display">
                  <span className="amount-value">
                    {convertAmount(item.totalAmount)}
                  </span>
                  <span className="amount-percentage">
                    {percentage}%
                  </span>
                </div>

                <div className="progress-bar-container">
                  <div 
                    className="progress-bar"
                    style={{
                      width: `${percentage}%`,
                      backgroundColor: getCategoryColor(item.head3)
                    }}
                  />
                </div>
              </div>

            </div>
          );
        })}

      </div>
    );
  })}

</div>


              {/* Category Legend */}
              
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="personal-dashboard-footer">
        <div className="personal-dashboard-footer-left">
          <div className="personal-dashboard-legend">
            <div className="personal-dashboard-legend-item">
              <div className="personal-dashboard-legend-color income"></div>
              <span>Income</span>
            </div>
            <div className="personal-dashboard-legend-item">
              <div className="personal-dashboard-legend-color investment"></div>
              <span>Investment</span>
            </div>
            <div className="personal-dashboard-legend-item">
              <div className="personal-dashboard-legend-color expense"></div>
              <span>Expense</span>
            </div>
            <div className="personal-dashboard-legend-item">
              <div className="personal-dashboard-legend-color debt"></div>
              <span>Debt</span>
            </div>
          </div>
        </div>
        <div className="personal-dashboard-footer-right">
          <p className="personal-dashboard-currency-note">
  Amount View: {amountView.toUpperCase()}
</p>

        </div>
      </div>
    </div>
  );
};

export default PersonalDashboard;